<template>
  <div class="requests-container">
    <v-expansion-panels multiple>
      <v-expansion-panel
        v-for="application in applications"
        :key="application.id"
      >
        <v-expansion-panel-header class="application-header">
          <div class="panel-header-inner">
            <span class="application-name">{{ application.name }}</span>
            <span class="request-info">
              {{ $t(`applications.numberOfApplications`) }} •
              {{ application.requests.length }} &nbsp; • &nbsp;
              {{ $t(`applications.lastApplication`) }} •
              {{ application.requests.course }}
            </span>
          </div>
        </v-expansion-panel-header>

        <v-expansion-panel-content>
          <v-card flat>
            <v-data-table
              :headers="tableHeaders"
              :items="application.requests"
              class="requests-table elevation-1"
              :hide-default-footer="true"
              :mobile-breakpoint="0"
              @click:row="(row) => handleClick(row, application)"
              dense
            >
              <template slot="item.status" slot-scope="{ item }">
                <v-chip :color="item.status_color" outlined class="status-chip">
                  {{ item.status }}
                </v-chip>
              </template>
              <!--              <template slot="item.actions" slot-scope="">-->
              <!--                <v-btn icon>-->
              <!--                  <v-icon>mdi-dots-vertical</v-icon>-->
              <!--                </v-btn>-->
              <!--              </template>-->
            </v-data-table>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <ProgressCircular v-if="isLoading" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ProgressCircular from "@/components/custom/ProgressCircular.vue";
import { showToast } from "@/utils/toast";

export default {
  components: { ProgressCircular },
  data() {
    return {
      isLoading: false,
      tableHeaders: [
        { text: "№", value: "id", sortable: false },
        { text: this.$t("applications.table.center"), value: "center" },
        { text: this.$t("applications.table.course"), value: "course" },
        { text: this.$t("applications.table.category"), value: "category" },
        {
          text: this.$t("applications.table.status"),
          value: "status",
          sortable: false,
        },
        { text: this.$t("applications.table.date"), value: "date" },
        {
          text: this.$t("applications.table.actions"),
          value: "actions",
          sortable: false,
        },
      ],
    };
  },
  created() {
    this.initializePageData();
  },
  methods: {
    ...mapActions({
      fetchApplications: "applications/loadApplications",
    }),
    async initializePageData() {
      if (this.isLoading) return;

      this.isLoading = true;
      try {
        await this.fetchApplications();
      } catch (error) {
        showToast(this, {
          text: `${this.$t(`toastText.errorData`)}: ${error}`,
          status: "error",
          duration: 3000,
        });
      } finally {
        this.isLoading = false;
      }
    },
    handleClick(row, application) {
      this.$router.push(
        `/profile/applications/${row.id}/student/${application.id}`
      );
    },
  },
  computed: {
    ...mapGetters("applications", ["applications"]),
  },
};
</script>

<style scoped>
::v-deep .v-data-table > .v-data-table__wrapper > table > tbody > tr > td,
.v-data-table > .v-data-table__wrapper > table > thead > tr > td,
.v-data-table > .v-data-table__wrapper > table > tfoot > tr > td {
  height: 60px;
}
::v-deep .v-data-table-header th {
  font-weight: bold;
  color: #272833 !important;
  font-size: 14px !important;
  height: 60px !important;
}
::v-deep .requests-table > .v-data-table__wrapper > table > tbody > tr:hover {
  cursor: pointer;
}

.requests-container {
  font-family: "Montserrat", sans-serif;
}
.panel-header-inner {
  display: flex;
  gap: 50px;
  align-items: center;
}
.application-header {
  display: flex;
  justify-content: space-between;
  font-size: 18px;
  font-weight: bold;
  font-family: "Montserrat Alternates", sans-serif;
}

.application-name {
  font-weight: bold;
}

.request-info {
  font-size: 14px;
  color: gray;
}

/* Таблица */
.requests-table {
  background: white;
  border-radius: 8px;
}

.status-chip {
  font-weight: bold;
  border-radius: 4px;
  font-size: 12px;
  height: fit-content;
}

@media (max-width: 500px) {
  .panel-header-inner {
    flex-direction: column;
    gap: 20px;
    align-items: start;
  }
}
@media (max-width: 600px) {
  .requests-container {
    padding: 0 15px;
  }
}
</style>
